import { Outlet } from "react-router-dom";
import { Header } from "../Header";
import { useLoading } from "@/hooks/useLoading";
import { Loading } from "../Loading";

export function Layout() {
  const { isLoading } = useLoading();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
        {isLoading && <Loading />}
      </main>
    </div>
  );
}
